import {CSSProperties, FC} from 'react';


export interface IIconAirbagBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconAirbagBmw: FC<IIconAirbagBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M8.5 4a3.986 3.986 0 1 1 .001 7.972 3.986 3.986 0 0 1 0-7.972Zm6.706 3.655c-.305 0-.588-.082-.84-.214A1.82 1.82 0 0 1 15.205 4c1.01 0 1.828.818 1.828 1.827 0 .49-.196.933-.51 1.262a1.82 1.82 0 0 1-1.318.566Zm2.93.265a.797.797 0 1 1 1.103 1.152l-1.159 1.109.072-.447a2.37 2.37 0 0 0-.29-1.551l.275-.263Zm-8.082 6.2c.215-.261.522-.415.848-.452.02.386.155.769.42 1.089l1.59 1.91-1.376-.309-2.604 3.173a1.28 1.28 0 0 1-1.804.178 1.282 1.282 0 0 1-.178-1.805l3.104-3.783Zm5.939-6.03a1.284 1.284 0 0 0-1.47 1.063l-.491 3.076.043.04c.037.034.074.068.108.108l2.032 2.442.842-5.26a1.283 1.283 0 0 0-1.064-1.47Zm-2.627 4.967a.797.797 0 0 0-1.226 1.02l4.606 5.536a.796.796 0 1 0 1.226-1.02l-4.606-5.536Z" clipRule="evenodd" />
        </svg>
    );
};
